import { render, staticRenderFns } from "./modal-editcontact.vue?vue&type=template&id=29a567f3&scoped=true&"
import script from "./modal-editcontact.vue?vue&type=script&lang=js&"
export * from "./modal-editcontact.vue?vue&type=script&lang=js&"
import style0 from "./modal-editcontact.vue?vue&type=style&index=0&id=29a567f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a567f3",
  null
  
)

export default component.exports